
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';
import ProductCard from '../../components/base/ProductCard';
import { updateSEO, seoData, getBaseURL } from '../../utils/seo';

export default function FemininoPage() {
  const [selectedFilter, setSelectedFilter] = useState('Todos');
  const [sortBy, setSortBy] = useState('Relevância');

  const filters = ['Todos', 'Vestidos', 'Blusas', 'Conjuntos', 'Calças', 'Saias'];
  const sortOptions = ['Relevância', 'Menor Preço', 'Maior Preço', 'Mais Novos'];

  const products = [
    {
      id: '1',
      image: 'https://public.readdy.ai/ai/img_res/04c6c86bbfefe77b9a63fdcac899ec22.jpg',
      brand: 'DLUXMEN',
      name: 'Vestido Elegante Premium',
      price: 'R$ 249,90',
      originalPrice: 'R$ 329,90',
      isNew: true
    },
    {
      id: '2',
      image: 'https://readdy.ai/api/search-image?query=luxury%20blouse%20for%20women%2C%20premium%20silk%20fabric%20with%20sophisticated%20cut%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20feminine%20style%20with%20emerald%20green%20brand%20details&width=400&height=500&seq=dluxmen-blouse-fem-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Blusa Seda Italiana',
      price: 'R$ 189,90',
      isNew: true
    },
    {
      id: '3',
      image: 'https://readdy.ai/api/search-image?query=luxury%20women%20complete%20outfit%20set%2C%20premium%20fabric%20quality%20with%20sophisticated%20styling%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20feminine%20ensemble%20with%20emerald%20green%20accents&width=400&height=500&seq=dluxmen-set-fem-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Conjunto Executivo Feminino',
      price: 'R$ 379,90',
      originalPrice: 'R$ 479,90'
    },
    {
      id: '4',
      image: 'https://readdy.ai/api/search-image?query=luxury%20pants%20for%20women%2C%20premium%20fabric%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20feminine%20trousers%20with%20emerald%20green%20brand%20details&width=400&height=500&seq=dluxmen-pants-fem-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Calça Social Premium',
      price: 'R$ 219,90'
    },
    {
      id: '5',
      image: 'https://readdy.ai/api/search-image?query=luxury%20skirt%20for%20women%2C%20premium%20fabric%20quality%20with%20sophisticated%20cut%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20feminine%20skirt%20with%20emerald%20green%20brand%20accents&width=400&height=500&seq=dluxmen-skirt-fem-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Saia Midi Elegante',
      price: 'R$ 169,90',
      isNew: true
    },
    {
      id: '6',
      image: 'https://readdy.ai/api/search-image?query=luxury%20blazer%20jacket%20for%20women%2C%20premium%20fabric%20with%20sophisticated%20tailoring%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20feminine%20blazer%20with%20emerald%20green%20brand%20details&width=400&height=500&seq=dluxmen-blazer-fem-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Blazer Alfaiataria Feminino',
      price: 'R$ 429,90',
      originalPrice: 'R$ 529,90'
    },
    {
      id: '7',
      image: 'https://readdy.ai/api/search-image?query=luxury%20top%20for%20women%2C%20premium%20cotton%20fabric%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20feminine%20top%20with%20emerald%20green%20brand%20accents&width=400&height=500&seq=dluxmen-top-fem-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Top Premium Básico',
      price: 'R$ 119,90'
    },
    {
      id: '8',
      image: 'https://readdy.ai/api/search-image?query=luxury%20cardigan%20for%20women%2C%20premium%20fabric%20with%20sophisticated%20knit%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20feminine%20cardigan%20with%20emerald%20green%20brand%20details&width=400&height=500&seq=dluxmen-cardigan-fem-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Cardigan Luxury Edition',
      price: 'R$ 289,90',
      originalPrice: 'R$ 359,90'
    }
  ];

  useEffect(() => {
    updateSEO({
      ...seoData.feminino,
      canonical: `${getBaseURL()}/feminino`,
      ogTitle: seoData.feminino.title,
      ogDescription: seoData.feminino.description,
      ogImage: `${getBaseURL()}/og-image.jpg`
    });
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F8F8', fontFamily: 'Montserrat, sans-serif' }}>
      <Header />

      {/* Page Header */}
      <section className="pt-24 pb-8" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <h1 
            className="text-5xl font-bold mb-4 max-md:text-3xl"
            style={{ 
              fontFamily: 'Cinzel Decorative, serif',
              color: '#0B0B0B'
            }}
          >
            Feminino
          </h1>
          <p 
            className="text-lg max-md:text-base"
            style={{ 
              color: '#C0C0C0',
              fontFamily: 'Montserrat, sans-serif'
            }}
          >
            Coleção premium de moda feminina com elegância e sofisticação
          </p>
        </div>
      </section>

      {/* Filters and Sort */}
      <section className="py-6 border-b" style={{ backgroundColor: '#F8F8F8', borderColor: '#C0C0C0' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between space-y-4 md:space-y-0">
            {/* Filters */}
            <div className="flex items-center space-x-6 overflow-x-auto pb-2 max-md:space-x-4">
              {filters.map((filter) => (
                <button
                  key={filter}
                  onClick={() => setSelectedFilter(filter)}
                  className={`text-sm font-medium uppercase tracking-wide whitespace-nowrap pb-2 border-b-2 transition-all duration-200 ${
                    selectedFilter === filter 
                      ? 'border-green-800 text-green-800' 
                      : 'border-transparent text-gray-600 hover:text-green-800'
                  }`}
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {filter}
                </button>
              ))}
            </div>

            {/* Sort */}
            <div className="flex items-center space-x-2">
              <span 
                className="text-sm font-medium"
                style={{ 
                  color: '#C0C0C0',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                Ordenar por:
              </span>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="text-sm font-medium border-none bg-transparent focus:outline-none pr-8"
                style={{ 
                  color: '#0B0B0B',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                {sortOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-md:gap-4">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                {...product}
                onClick={() => {
                  console.log('Produto clicado:', product.name);
                }}
              />
            ))}
          </div>

          {/* Load More */}
          <div className="text-center mt-12">
            <button
              className="px-8 py-3 font-semibold text-white rounded-lg transition-all duration-300 hover:bg-green-700"
              style={{ 
                backgroundColor: '#0F3F2F',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Carregar Mais Produtos
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
